module.exports = __webpack_public_path__ + "static/img/8.1608f50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/download-new/8.png
// module id = 5YaV
// module chunks = 2